import React from 'react';

const EditorPage = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>Editor</h1>
    <p>Willkommen im Editor.</p>
  </div>
);

export default EditorPage;
